import api from '@/services/api'

const state = {
  current: { active: 0, sites: [] },
}

// getters
const getters = {}

// actions
const actions = {
  add ({ commit }, data) {
    return new Promise( (resolve) => {
      api().post(`/customer/${data.guid}/datamodel`, data.data ).then( (response) => {
        if(response.data.code == -1) {
          resolve(response.data);
        } else resolve(response.data);
      })
    })
  },
  edit ({ commit }, data) {
    return new Promise( (resolve) => {
      api().patch(`/customer/${data.guid}/datamodel/${data.id}`, data.data ).then( (response) => {
        if(response.data.code == -1) {
          resolve(response.data);
        } else resolve(response.data);
      })
    })
  },
  delete ({ commit }, data) {
    return new Promise( (resolve) => {
      api().delete(`/customer/${data.guid}/datamodel/${data.id}`).then( (response) => {
        resolve()
      })
    })
  },
  list({ commit }, guid) {
    return new Promise( (resolve, reject) => {
      api().get(`/customer/${guid}/datamodels`).then(response => {
        resolve(response.data.data)
      }, (error) => {
        console.log(error)
        reject(error);
      })
    });
  },
  sites({ commit }) {
    return new Promise( (resolve) => {
      api().get('/customer/user/sites').then( (response) => {
        resolve(response.data.data)
      })
    })
  },
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/models.js